import request from '@/utils/request';

export const getClockInList = (params: any) =>
  request({
    url: 'PunchTheClock/clockList',
    method: 'get',
    params
  });

export const getClockInExport = (data: any) =>
  request({
    url: 'PunchTheClock/export',
    method: 'POST',
    data
  });
